import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M2.75 1.5C2.47386 1.5 2.25 1.72386 2.25 2V10C2.25 10.2761 2.47386 10.5 2.75 10.5H7.25C8.63071 10.5 9.75 9.38071 9.75 8C9.75 7.06148 9.23284 6.24374 8.46795 5.81623C8.94955 5.36053 9.25 4.71535 9.25 4C9.25 2.61929 8.13071 1.5 6.75 1.5H2.75ZM6.75 5.5C7.57843 5.5 8.25 4.82843 8.25 4C8.25 3.17157 7.57843 2.5 6.75 2.5H3.25V5.5H6.75ZM3.25 6.5V9.5H7.25C8.07843 9.5 8.75 8.82843 8.75 8C8.75 7.17157 8.07843 6.5 7.25 6.5H3.25Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.66667 2C3.29848 2 3 2.29848 3 2.66667V13.3333C3 13.7015 3.29848 14 3.66667 14H9.66667C11.5076 14 13 12.5076 13 10.6667C13 9.4153 12.3105 8.32499 11.2906 7.75497C11.9327 7.14738 12.3333 6.28714 12.3333 5.33333C12.3333 3.49238 10.8409 2 9 2H3.66667ZM9 7.33333C10.1046 7.33333 11 6.4379 11 5.33333C11 4.22876 10.1046 3.33333 9 3.33333H4.33333V7.33333H9ZM4.33333 8.66667V12.6667H9.66667C10.7712 12.6667 11.6667 11.7712 11.6667 10.6667C11.6667 9.5621 10.7712 8.66667 9.66667 8.66667H4.33333Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.58333 2.5C4.1231 2.5 3.75 2.8731 3.75 3.33333V16.6667C3.75 17.1269 4.1231 17.5 4.58333 17.5H12.0833C14.3845 17.5 16.25 15.6345 16.25 13.3333C16.25 11.7691 15.3881 10.4062 14.1132 9.69371C14.9159 8.93422 15.4167 7.85892 15.4167 6.66667C15.4167 4.36548 13.5512 2.5 11.25 2.5H4.58333ZM11.25 9.16667C12.6307 9.16667 13.75 8.04738 13.75 6.66667C13.75 5.28595 12.6307 4.16667 11.25 4.16667H5.41667V9.16667H11.25ZM5.41667 10.8333V15.8333H12.0833C13.464 15.8333 14.5833 14.714 14.5833 13.3333C14.5833 11.9526 13.464 10.8333 12.0833 10.8333H5.41667Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.75 8C8.75 7.17157 8.07843 6.5 7.25 6.5H3.25V9.5H7.25C8.07843 9.5 8.75 8.82843 8.75 8ZM8.25 4C8.25 3.17157 7.57843 2.5 6.75 2.5H3.25V5.5H6.75C7.57843 5.5 8.25 4.82843 8.25 4ZM9.25 4C9.25 4.71558 8.94866 5.3602 8.4668 5.81592C9.23224 6.24328 9.75 7.06106 9.75 8C9.75 9.38071 8.63071 10.5 7.25 10.5H2.75C2.47386 10.5 2.25 10.2761 2.25 10V2L2.25244 1.94873C2.27811 1.69667 2.49116 1.5 2.75 1.5H6.75C8.13071 1.5 9.25 2.61929 9.25 4Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.6667 10.6667C11.6667 9.5621 10.7712 8.66667 9.66667 8.66667H4.33333V12.6667H9.66667C10.7712 12.6667 11.6667 11.7712 11.6667 10.6667ZM11 5.33333C11 4.22876 10.1046 3.33333 9 3.33333H4.33333V7.33333H9C10.1046 7.33333 11 6.4379 11 5.33333ZM12.3333 5.33333C12.3333 6.28744 11.9315 7.14693 11.2891 7.75456C12.3097 8.32437 13 9.41475 13 10.6667C13 12.5076 11.5076 14 9.66667 14H3.66667C3.29848 14 3 13.7015 3 13.3333V2.66667L3.00326 2.59831C3.03748 2.26222 3.32155 2 3.66667 2H9C10.8409 2 12.3333 3.49238 12.3333 5.33333Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5833 13.3333C14.5833 11.9526 13.464 10.8333 12.0833 10.8333H5.41667V15.8333H12.0833C13.464 15.8333 14.5833 14.714 14.5833 13.3333ZM13.75 6.66667C13.75 5.28595 12.6307 4.16667 11.25 4.16667H5.41667V9.16667H11.25C12.6307 9.16667 13.75 8.04738 13.75 6.66667ZM15.4167 6.66667C15.4167 7.8593 14.9144 8.93366 14.1113 9.6932C15.3871 10.4055 16.25 11.7684 16.25 13.3333C16.25 15.6345 14.3845 17.5 12.0833 17.5H4.58333C4.1231 17.5 3.75 17.1269 3.75 16.6667V3.33333L3.75407 3.24788C3.79685 2.82778 4.15194 2.5 4.58333 2.5H11.25C13.5512 2.5 15.4167 4.36548 15.4167 6.66667Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconBold01: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"bold-01"} {...props} />
);
